import * as React from 'react'
import Cloudy from 'images/ico_cloudy.svg'
import Moon from 'images/ico_moon.svg'
import SeaTemp from 'images/ico_sea_temperature_red.svg'
import Rain from 'images/ico_rainy.svg'
import SunnyDays from 'images/ico_sunny_days.svg'
import Lightbulb from 'images/ico_lightbulb.svg'
import Sun from 'images/ico_sun_red.svg'
import Drop from 'images/ico_drop.svg'

type StatsCardProps = {
    iconType: 'temperature' | 'seaTemperature' | 'nightTemperature' | 'rainyDays' | 'sunnyDays' | 'dayLight' | 'sunshine' | 'humidity'
    title: string
    color?: string
    mainStat: string | React.ReactNode
    additionalInfo?: string | React.ReactNode

}

export const StatsCard = ({iconType, title, mainStat, color, additionalInfo}: StatsCardProps) => {
    const iconSources = {
        temperature: Cloudy,
        seaTemperature: SeaTemp,
        nightTemperature: Moon,
        rainyDays: Rain,
        sunnyDays: SunnyDays,
        dayLight: Lightbulb,
        sunshine: Sun,
        humidity: Drop
    }
    return (<div className="destination__stats__card">
        <img src={iconSources[iconType]} alt="" className="destination__stats__img opacity--60"/>
        <p className="destination__stats--desc_start">{title}</p>
        <p style={color ? { color: color} : undefined} className="destination__stats--main">{mainStat}</p>
        {typeof additionalInfo === 'string' ? <p className="destination__stats__desc">{additionalInfo}</p> : additionalInfo }
    </div>)
}
